import React,{useState} from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {useAuth} from '../../context/AuthContext';
import BeltPicker from '../BeltPicker';
import {useDojangs} from '../../hooks/useDojangs';
import AuthLayout,{AuthField,AuthError,authInputClass,TEXT_SHADOW} from './AuthLayout';

const {FiUser,FiMail,FiLock,FiPhone,FiArrowRight}=FiIcons;

const MIN_PASSWORD_LENGTH=6;

// `onBack` se usa cuando un invitado se registra desde su perfil: en lugar de ir al login, regresa.
export default function Register({onShowLogin,onBack}) {
  const [form,setForm]=useState({name: '',email: '',phone: '',birthDate: '',tkdStartDate: '',belt: 'blanca',dojang: '',dojangOther: '',password: '',confirm: ''});
  const [error,setError]=useState('');
  const [submitting,setSubmitting]=useState(false);
  const {register}=useAuth();
  const {dojangs}=useDojangs();

  const update=(field)=> (e)=> setForm({...form,[field]: e.target.value});

  const handleSubmit=async (e)=> {
    e.preventDefault();
    setError('');
    if (form.password!==form.confirm) {
      setError('Las contraseñas no coinciden');
      return;
    }
    setSubmitting(true);
    try {
      const {confirm,...data}=form;
      await register(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      wide
      subtitle="Registro de alumnos"
      footer={onBack ? (
        <button type="button" onClick={onBack} className="w-full bg-black/40 border border-white/40 hover:bg-black/55 hover:border-white text-white py-4 rounded-2xl font-black uppercase tracking-[0.3em] text-[11px] transition-all active:scale-95">
          Volver
        </button>
      ) : (
        <div className="space-y-5">
          <div className="flex items-center gap-4">
            <div className="h-px flex-1 bg-white/30" />
            <span className="text-white text-[10px] font-black uppercase tracking-[0.3em] [text-shadow:_0_1px_6px_rgba(0,0,0,0.9)]">¿Ya tienes cuenta?</span>
            <div className="h-px flex-1 bg-white/30" />
          </div>
          <button type="button" onClick={onShowLogin} className="w-full bg-black/40 border border-white/40 hover:bg-black/55 hover:border-white text-white py-4 rounded-2xl font-black uppercase tracking-[0.3em] text-[11px] transition-all active:scale-95">
            Iniciar sesión
          </button>
        </div>
      )}
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          <AuthField label="Nombre completo *" icon={FiUser}>
            <input required autoComplete="name" maxLength={120} value={form.name} onChange={update('name')} className={authInputClass()} />
          </AuthField>
          <AuthField label="Email *" icon={FiMail}>
            <input type="email" required autoComplete="email" value={form.email} onChange={update('email')} className={authInputClass()} placeholder="ejemplo@dojang.com" />
          </AuthField>
          <AuthField label="Dojang *">
            <select required value={form.dojang} onChange={update('dojang')} className={`${authInputClass(false)} appearance-none [color-scheme:dark]`}>
              <option value="" disabled>Selecciona tu dojang</option>
              {dojangs.map(d=> <option key={d.id} value={d.id}>{d.label}</option>)}
            </select>
          </AuthField>
          {form.dojang==='otro' && (
            <AuthField label="Nombre de tu dojang *">
              <input required maxLength={80} value={form.dojangOther} onChange={update('dojangOther')} className={authInputClass(false)} placeholder="Escribe el nombre de tu dojang" />
            </AuthField>
          )}
          <AuthField label="Teléfono" icon={FiPhone}>
            <input type="tel" autoComplete="tel" maxLength={30} value={form.phone} onChange={update('phone')} className={authInputClass()} />
          </AuthField>
          <AuthField label="Fecha de nacimiento">
            <input type="date" min="1900-01-01" max={new Date().toLocaleDateString('en-CA')} value={form.birthDate} onChange={update('birthDate')} className={`${authInputClass(false)} [color-scheme:dark]`} />
          </AuthField>
          <AuthField label="Fecha de ingreso al TKD">
            <input type="date" min={form.birthDate || '1900-01-01'} max={new Date().toLocaleDateString('en-CA')} value={form.tkdStartDate} onChange={update('tkdStartDate')} className={`${authInputClass(false)} [color-scheme:dark]`} />
          </AuthField>
        </div>

        <AuthField label="Tu grado actual *">
          <div className="pt-2">
            <BeltPicker value={form.belt} onChange={belt=> setForm({...form,belt})} />
          </div>
        </AuthField>

        <div className="grid md:grid-cols-2 gap-6">
          <AuthField label="Contraseña *" icon={FiLock}>
            <input type="password" required minLength={MIN_PASSWORD_LENGTH} autoComplete="new-password" value={form.password} onChange={update('password')} className={authInputClass()} placeholder={`Mínimo ${MIN_PASSWORD_LENGTH} caracteres`} />
          </AuthField>
          <AuthField label="Confirmar contraseña *" icon={FiLock}>
            <input type="password" required minLength={MIN_PASSWORD_LENGTH} autoComplete="new-password" value={form.confirm} onChange={update('confirm')} className={authInputClass()} />
          </AuthField>
        </div>

        <AuthError message={error} />

        <button type="submit" disabled={submitting} className="w-full bg-red-600 hover:bg-red-500 disabled:opacity-60 text-white py-5 rounded-2xl font-black uppercase tracking-[0.3em] text-[10px] transition-all shadow-xl shadow-red-600/20 active:scale-95 flex items-center justify-center gap-2">
          {submitting ? 'Creando cuenta...' : 'Crear mi cuenta'} <SafeIcon icon={FiArrowRight} />
        </button>
      </form>
    </AuthLayout>
  );
}
